<template>
    <div class="animated fadeIn">
      <b-button
        type="button"
        size="sm"
        variant="primary"
        v-show="'active' === membership.status"
        v-on:click="cancelMembership"
        :disabled="disabled"
      ><i class="fa fa-window-close"></i> Cancel
      </b-button>
    </div>
</template>
<script>
    import {Membership} from "../../../models/Membership"
    import {RepositoryFactory} from "../../../services/repositories/RepositoryFactory";
    import {handleErrors} from "../../../shared/utils";

    const MembershipRepo = RepositoryFactory.get('membership');

    export default {
        name: 'membership-button-cancel',
        props: {
            membership: {
                type: Object,
                default: new Membership(),
            },
        },
        data() {
            return {
                disabled: false,
                sendMail: true,
            }
        },
        methods: {
            cancelMembership() {
                this.disabled = true
                this.$emit('click')
                MembershipRepo
                    .cancelMembership(this.membership.id)
                    .then(
                        response =>
                            (
                                this.$emit('cancelled', response.data.data),
                                this.disabled = false
                            )
                    )
                    .catch(
                        response => (
                            this.returnErrors(response)
                        )
                    )
            },
            returnErrors(response) {
                handleErrors(response).forEach(
                    value => {
                        this.flash(value,'error')
                    }
                )
                this.$emit('click')
                this.disabled = false
            },
        },
    }
</script>
